import Tabit from 'tabit';

function Tabs() {
  const self = this;

  self.init = function init(element) {
    const $el = $(element);
    if ($el.data('app-module-initialized')) return; // Prevent double init

    new Tabit(element, {
      buttonSelector: '.js-tabs__btn',
      contentSelector: '.js-tabs__content',
      buttonActiveClass: 'is-active',
      onChange(tab) {
        const carousel = tab.content.querySelector('.js-carousel__list');
        if (!carousel) return;

        const $carousel = $(carousel);

        if ($carousel.slick) {
          $carousel.slick('setPosition');
        }
      },
    });

    $el.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-tabs').each(function init() {
      self.init(this);
    });
  };
}

export default new Tabs();
